import { render, staticRenderFns } from "./UgiNotifications.vue?vue&type=template&id=ab2ae43e&scoped=true&"
import script from "./UgiNotifications.vue?vue&type=script&lang=js&"
export * from "./UgiNotifications.vue?vue&type=script&lang=js&"
import style0 from "./UgiNotifications.vue?vue&type=style&index=0&id=ab2ae43e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2ae43e",
  null
  
)

export default component.exports